export default __webpack_public_path__ + "static/media/charm-s3.8104f7aa.png";